import { forwardRef } from "react";
import Button from "components/Button";
import { Link } from "react-router-dom";
import type { LinkProps as RouterLinkProps } from "react-router-dom";
import type { ButtonProps } from "components/Button/Button";

// Extend ButtonProps with RouterLinkProps
type ButtonLinkProps = Omit<ButtonProps, "href"> & RouterLinkProps;

/**
 * ButtonLink component extends Button and implements react-router-dom's Link component.
 */
const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>((props, ref) => {
  return <Button component={Link} ref={ref} {...props} />;
});

export default ButtonLink;
